import { useUserContext } from "../contexts/UserContext";

export function useHasRole(role) {
  const { permissions = [] } = useUserContext();
  return permissions.includes(role);
}
